<template>
	<div>
        <b-modal id="modalAddToLister" 
            ref="modalAddToLister"
            size="md" 
            :title="transUF('add to lists')"
            @ok="addToList"
        >
            <Multiselect 
                v-model="selectedCustomers"
                :options="customers"
                label="name"
                track-by="id"
                :groupSelect="false"
                :close-on-select="true"
                multiple
            ></Multiselect>
        </b-modal>
	</div>
</template>

<script>
export default {
    name : 'AddToLister',
    props : [ 'addableRef', 'customers', 'obj' ],
    methods : {
        show() {
            this.$refs.modalAddToLister.show()
        },
        addToList() {
            var t = this
            var journalist_ids = []
            journalist_ids.push(t.obj.id)
            window.axios.post('/api/journalists/add-to-blacklists', {
                ids : journalist_ids,
                customers : t.selectedCustomers
            }).then(function() {
                window.notify('success', 'Oggetti inseriti nelle blacklist selezionate')
                t.selectedCustomers = []
                t.$parent.$refs[t.addableRef].refresh()
            })
        }
    },
    data() {
        return {
            selectedCustomers : []
        }
    }
}
</script>